export default __webpack_public_path__ + "static/media/025-eggs.21357236.svg";